module.exports = __webpack_public_path__ + "img/odt.ae60ed74.svg";